import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AuthWrapper from "@/components/AuthWrapper";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import PlanTypes from "@/pages/PlanTypes";
import RenewalTasks from "@/pages/RenewalTasks";
import AdminUsers from "@/pages/AdminUsers";
import SMSSettings from "@/pages/SMSSettings";
import BigScreenDashboard from "@/pages/BigScreenDashboard";

function App() {
  return (
    <div className="App min-h-screen bg-[#020617]">
      <BrowserRouter>
        <Routes>
          {/* Public Big Screen Dashboard - No Auth */}
          <Route path="/bigscreen" element={<BigScreenDashboard />} />
          
          {/* Protected Management Routes */}
          <Route path="/*" element={
            <AuthWrapper>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="customers" element={<Customers />} />
                  <Route path="plan-types" element={<PlanTypes />} />
                  <Route path="tasks" element={<RenewalTasks />} />
                  <Route path="sms-settings" element={<SMSSettings />} />
                  <Route path="admin-users" element={<AdminUsers />} />
                </Route>
              </Routes>
            </AuthWrapper>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#0f172a',
            border: '1px solid #1e293b',
            color: '#F8FAFC'
          }
        }}
      />
    </div>
  );
}

export default App;
